// extracted by mini-css-extract-plugin
export default {"accent":"documentation_accent__npgeB"};